import styled from 'styled-components';
import { colors } from '@/constants';

export const GroupContainer = styled.section<{ $isActive?: boolean }>`
    width: 100%;
    margin-bottom: 12px;
    background-color: ${colors.brand.white};
    border: 1px solid ${({ $isActive }) => ($isActive ? colors.grey11 : colors.alert.orange300)};
    border-radius: 8px;
    overflow: hidden;
`;

export const GroupHeader = styled.div<{ $isActive?: boolean; $clickable?: boolean }>`
    padding: 12px 18px;
    border-bottom: 1px solid ${colors.grey11};
    background-color: ${({ $isActive }) => ($isActive ? colors.alert.green50 : colors.alert.orange100)};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};

    &:focus-visible {
        outline: 2px solid ${colors.alert.orange300};
        outline-offset: -2px;
    }
`;

export const GroupHeaderContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
    min-width: 0;
`;

export const GroupsProgressLabel = styled.span`
    font-family: Roboto, sans-serif;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.2;
    color: ${colors.brand.grafite};
`;

export const GroupTitle = styled.h3<{ $isActive?: boolean }>`
    margin: 0;
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.2;
    color: ${({ $isActive }) => ($isActive ? colors.alert.green300 : colors.alert.orange300)};
    min-width: 0;
`;

export const GroupHeaderMeta = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
`;

export const KitMultiplier = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    padding: 4px 8px;
    border-radius: 999px;
    background-color: ${colors.alert.green100};
    border: 1px solid ${colors.alert.green110};
    font-family: Roboto, sans-serif;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    color: ${colors.alert.green300};
`;

export const InProgressLabel = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px 10px;
    border-radius: 999px;
    background-color: ${colors.brand.white};
    border: 1px solid ${colors.alert.orange300};
    font-family: Roboto, sans-serif;
    font-size: 11px;
    font-weight: 700;
    line-height: 1;
    color: ${colors.alert.orange300};
    white-space: nowrap;
`;

export const NoDiscountNote = styled.span`
    font-family: Roboto, sans-serif;
    font-size: 11px;
    font-weight: 700;
    line-height: 1.3;
    color: ${colors.alert.red200};
`;

export const GroupProducts = styled.div`
    display: flex;
    flex-direction: column;
`;

export const GroupProductItem = styled.div<{ $hasDivider?: boolean }>`
    border-bottom: ${({ $hasDivider }) => ($hasDivider ? `1px solid ${colors.background1}` : 'none')};
`;
